export default "__VITE_ASSET__CdYEsUC2__"